export default __webpack_public_path__ + "static/media/testimonial-bg.20fd49d1.png";